<div class="card h-[calc(100vh-200px)] flex flex-col" [@simpleFadeAnimation]="'in'">
  <div class="flex items-center justify-between card-header">
    <h3 class="card-title">Pending Transactions</h3>
    <span class="items-rows">
      <gd-btnviews
        *ngIf="viewButtons"
        [selectedView]="selectedView"
        (viewEmitter)="onViewChange($event)"
      ></gd-btnviews>
    </span>
  </div>
  <div kendoWindowContainer></div>
  <div kendoDialogContainer></div>
  <div class="space-y-6 card-body flex flex-col flex-1 overflow-hidden">
    <div class="card shrink-0">
      <div class="card-body">
        <div class="header-container">
          <div class="flex items-center gap-4 header-actions-container">
            <kendo-dropdownlist
              #selectbranch
              style="width: 150px"
              id="pendingscreen"
              [data]="passinggridId"
              [defaultItem]="defaultBranchNumber"
              [value]="selectedBranchNumber"
              (valueChange)="onFilterByBranchChange($event)"
            ></kendo-dropdownlist>
            <button
              [hidden]="filter.filters.length === 0"
              class="btn btn-outline btn-danger btn-sm"
              (click)="clearFilters()"
            >
              Clear Filters
            </button>
          </div>
          <div
            class="flex flex-wrap gap-2 mt-4 text-sm legend no-margin text-muted"
          >
            <span class="legend-item"
              ><ng-icon name="heroEye" title="Review Summary"></ng-icon> Review
              Summary</span
            >
            <span class="legend-item"
              ><ng-icon
                name="heroMagnifyingGlass"
                title="Account Form Report"
              ></ng-icon>
              Account Form Report</span
            >
            <span class="legend-item"
              ><ng-icon
                name="heroArchiveBox"
                title="Account Form Review"
              ></ng-icon>
              Account Form Review</span
            >
            <span class="legend-item"
              ><ng-icon name="heroPencil" title="Edit Transaction"></ng-icon>
              Edit Transaction</span
            >
            <span class="legend-item"
              ><ng-icon name="heroFolder" title="View Files"></ng-icon> View
              Files</span
            >
          </div>
        </div>
      </div>
    </div>

    <div class="card flex-1 overflow-hidden" id="pendingtgrid">
      <kendo-grid
        style="height: 100%"
        [data]="view"
        [pageable]="true"
        [pageSize]="pageSize"
        [skip]="skip"
        [sortable]="true"
        size="small"
        [sort]="sort"
        [filter]="filter"
        [resizable]="true"
        [filterable]="true"
        [navigable]="true"
        [rowClass]="rowCallback"
        [scrollable]="'scrollable'"
        (sortChange)="sortChange($event)"
        (filterChange)="onFilterChange($event)"
        (pageChange)="onPageChange($event)"
      >
        <kendo-grid-column
          *ngFor="let column of columns"
          [field]="column.field"
          [title]="column.title"
          [width]="column.width"
          [filterable]="column.filterable"
          [hidden]="column.hidden"
          [format]="column.format"
          [ngSwitch]="column.template"
        >
          <ng-template
            *ngSwitchCase="'bookmark'"
            kendoGridCellTemplate
            let-dataItem
          >
            <span>
              <a
                (click)="
                  isBookmarked(dataItem)
                    ? bookMarksremoved(dataItem.blotterId, dataItem.bookm)
                    : bookMarks(dataItem.blotterId)
                "
                routerLinkActive="router-link-active"
                [ngClass]="{
                  'black-color': !isBookmarked(dataItem),
                  'blue-color': isBookmarked(dataItem)
                }"
              >
                <ng-icon name="heroBookmarkSolid"></ng-icon>
              </a>
            </span>
          </ng-template>
          <ng-template
            *ngSwitchCase="'repName'"
            kendoGridFilterCellTemplate
            let-filter
          >
            <gd-dropdown-filter
              [filter]="filter"
              [data]="passingrepfilter"
              [defaultTextString]="'Filter By Rep'"
              textField="repName"
              valueField="repName"
            ></gd-dropdown-filter>
          </ng-template>
          <ng-template
            *ngSwitchCase="'viewAccount'"
            kendoGridCellTemplate
            let-dataItem
          >
            <div
              class="selectable"
              title="View/Edit Account"
              (click)="viewClientInfo(dataItem.clientId)"
            >
              {{ dataItem.accountName }}
            </div>
          </ng-template>
          <ng-template
            *ngSwitchCase="'date'"
            kendoGridCellTemplate
            let-dataItem
          >
            {{ dataItem[column.field] | date : 'MM/dd/yyyy' }}
          </ng-template>
          <ng-template
            *ngSwitchCase="'statusType'"
            kendoGridCellTemplate
            let-dataItem
          >
            <span *ngIf="dataItem.statusTypeId === 0">
              {{ dataItem.statusTypeDesc }}
            </span>
            <span *ngIf="dataItem.statusTypeId === 5">
              Pending - preliminary review complete
            </span>
            <span *ngIf="dataItem.statusTypeId === 1">
              Submitted for Review
            </span>
            <span *ngIf="dataItem.statusTypeId === 4">
              Pending - paperwork review complete
            </span>
            <span *ngIf="dataItem.statusTypeId === 2">
              Pending - incomplete paperwork (notify rep)
            </span>
            <span *ngIf="dataItem.statusTypeId === 3">
              Pending - insurance review
            </span>
            <span *ngIf="dataItem.statusTypeId === 6">
              Pending - insurance approved, compliance pending
            </span>
            <span *ngIf="dataItem.statusTypeId === 7">
              Pending - principal review issue
            </span>
            <span *ngIf="dataItem.statusTypeId === 8">
              Insurance Rejection (notify rep)
            </span>
            <span *ngIf="dataItem.statusTypeId === 9">
              Compliance Rejection (notify rep)
            </span>
            <span *ngIf="dataItem.statusTypeId === 10">
              Approved - incidental incomplete paperwork (notify rep)
            </span>
            <span *ngIf="dataItem.statusTypeId === 11">Approved</span>
            <span *ngIf="dataItem.statusTypeId === 12">
              Rejected - case closed
            </span>
            <span *ngIf="dataItem.statusTypeId === -2">
              <kendo-dropdownlist
                [data]="dropdownStatusLight"
                [valuePrimitive]="true"
                size="small"
                (valueChange)="
                  handleOrderChange(dataItem.statusTypeId, dataItem.blotterId) 
                "
                [(ngModel)]="dataItem.statusTypeId"
                textField="text"
                valueField="value"
                [popupSettings]="{
                  width: 250,
                  height: 150
                }"
                style="width: 100%; font-size: 11px"
              >
              </kendo-dropdownlist>
            </span>
          </ng-template>
        </kendo-grid-column>
        <!-- ##################   ReviewTransaction  ################################# -->
        <kendo-grid-column [width]="40" [sticky]="true" headerClass="no-border" [filterable]="false">
          <ng-template kendoGridCellTemplate let-dataItem>
            <div *ngIf="dataItem.showReviewTransaction">
              <a
                class="icon-btn"
                title="Review Summary"
                (click)="
                  ReviewAccountReviewTransactionsview(
                    dataItem.blotterId,
                    dataItem.clientId,
                    dataItem.repId,
                    dataItem.clientName,
                    dataItem.statusTypeId,
                    dataItem.transactionTypeId,
                    dataItem.productTypeId,
                    dataItem.showReviewTransaction,
                    dataItem.showAccountReview,
                    dataItem.state,
                    dataItem.repCodeId
                  )
                "
              >
                <ng-icon name="heroEye" class="xl"></ng-icon>
              </a>
            </div>
          </ng-template>
          <ng-template kendoGridCellTemplate let-dataItem #second>
            <span>&nbsp;</span>
          </ng-template>
        </kendo-grid-column>
        <kendo-grid-column [width]="40" [sticky]="true" headerClass="no-border" [filterable]="false">
          <ng-template kendoGridCellTemplate let-dataItem>
            <div
              *ngIf="
                dataItem.accountFormReviewCount > 0 &&
                dataItem.statusTypeId > -2 &&
                dataItem.newAccountForm === 'On File' &&
                dataItem.blotterId > 0
              "
            >
              <a
                class="icon-btn"
                (click)="openForm(dataItem)"
                title="Account Form Receipt"
              >
                <ng-icon name="heroMagnifyingGlass" class="xl"></ng-icon>
              </a>
            </div>
          </ng-template>
        </kendo-grid-column>
        <!-- ############# Account Form Review ######################## -->
        <kendo-grid-column
          [filterable]="false"
          [width]="40"
          [sticky]="true"
          headerClass="no-border"
        >
          <ng-template kendoGridCellTemplate let-dataItem>
            <div *ngIf="dataItem.showAccountReview">
              <a
                class="icon-btn"
                title="Account Form Review 3"
                (click)="
                  ReviewAccountTransactionsview(
                    dataItem.blotterId,
                    dataItem.clientId,
                    dataItem.repId,
                    dataItem.clientName,
                    dataItem.statusTypeId,
                    dataItem.transactionTypeId,
                    dataItem.productTypeId,
                    dataItem.showReviewTransaction,
                    dataItem.showAccountReview,
                    dataItem.state,
                    dataItem.repCodeId
                  )
                "
              >
                <ng-icon name="heroArchiveBox" class="xl"></ng-icon>
              </a>
            </div>
          </ng-template>
          <ng-template kendoGridCellTemplate let-dataItem #second>
          </ng-template>
        </kendo-grid-column>
        <kendo-grid-column
          title=""
          [filterable]="false"
          [width]="40"
          [sticky]="true"
          headerClass="no-border"
        >
          <ng-template kendoGridCellTemplate let-dataItem [sticky]="true">
            <a
              (click)="
                EditTransactions(
                  dataItem.blotterId,
                  dataItem.clientId,
                  dataItem.repId,
                  dataItem.clientName,
                  dataItem.statusTypeId,
                  dataItem.transactionTypeId,
                  dataItem.productTypeId,
                  dataItem.showReviewTransaction,
                  dataItem.showAccountReview,
                  dataItem.state,
                  dataItem.repCodeId
                )
              "
              routerLinkActive="router-link-active"
              class="icon-btn"
              title="Edit Transaction"
            >
              <ng-icon name="heroPencil" class="xl"></ng-icon>
            </a>
          </ng-template>
        </kendo-grid-column>
        <kendo-grid-column title="" [filterable]="false" [width]="40"  [sticky]="true" headerClass="no-border">
          <ng-template kendoGridCellTemplate let-dataItem>
            <a
              (click)="
                viewFiles(
                  dataItem.repId,
                  dataItem.clientName,
                  dataItem.blotterId,
                  dataItem.clientId,
                  'blotterId'
                )
              "
              routerLinkActive="router-link-active"
              title="View Files"
              class="icon-btn"
            >
              <ng-icon name="heroFolder" class="xl"></ng-icon>
            </a>
          </ng-template>
        </kendo-grid-column>
      </kendo-grid>

      <kendo-window
        title="View Client"
        animate="animates"
        (stateChange)="onStateChange($event)"
        *ngIf="openup"
        [top]="50"
        [left]="250"
        (close)="onDialogReciptClose()"
        [width]="850"
      >
        <gd-clienttrans
          [ngClass]="{
            max: enlarge === 'maximized',
            def: enlarge === 'default'
          }"
          [outputBlotterId]="blotId"
        ></gd-clienttrans>
      </kendo-window>
    </div>
  </div>
</div>
